import { useCurrentUser } from '../../contexts/CurrentUserContext';

/**
 * `/staff/me` failed, so every display field and every landing route derived
 * from the staff profile is a default rather than this viewer's own (BON-558).
 *
 * The failure is otherwise silent, and silently WRONG rather than merely
 * missing: a Regional Director with no regions reads as a Regional Director
 * who has none, and lands on routes chosen for someone with none. Saying so is
 * what separates "degraded, and here is why" from a plausible-looking wrong
 * answer nobody reports.
 *
 * `CurrentUserProvider` has already retried once automatically; the button is
 * the manual attempt after that, so the viewer is never stuck waiting for a
 * page reload to fix it.
 */
export default function ProfileUnavailableBanner() {
  const { refresh } = useCurrentUser();

  return (
    <div
      role="alert"
      className="flex flex-wrap items-center gap-x-3 gap-y-1 px-4 py-2 text-sm font-medium text-white bg-clay-600"
    >
      <span>
        We couldn&rsquo;t load your staff profile, so your name, your regions and the pages Nebari
        opens for you are showing defaults instead of your own.
      </span>
      <button
        type="button"
        onClick={refresh}
        className="font-semibold underline underline-offset-2 rounded-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white"
      >
        Try again
      </button>
    </div>
  );
}
